import React, { Suspense, lazy } from 'react';
import { Hero } from './components/Hero';

/**
 * WOODWORKING PROJECTS THAT SELL™ — Christmas premium (v3).
 * HERO → SNAPSHOT → BEST SELLERS → 2x4 TREE PREVIEW → 6 VOLUMES → BONUSES →
 * OFFER → GUARANTEE → TECH PROOF → FAQ → FINAL CTA → FOOTER.
 */
const named = <K extends string,>(loader: () => Promise<Record<K, React.ComponentType>>, key: K) => lazy(() => loader().then(m => ({
  default: m[key]
})));
const ValueStrip = named(() => import('./components/sections/ValueStrip'), 'ValueStrip');
const AudiencePainSection = named(() => import('./components/sections/ExtraSections'), 'AudiencePainSection');
const GuaranteeSection = named(() => import('./components/sections/ExtraSections'), 'GuaranteeSection');
const ProjectPreviewSection = named(() => import('./components/sections/ProjectPreviewSection'), 'ProjectPreviewSection');
const TechProofSection = named(() => import('./components/sections/TechProofSection'), 'TechProofSection');
const CollectionSection = named(() => import('./components/sections/CollectionSection'), 'CollectionSection');
const BonusSection = named(() => import('./components/sections/BonusSection'), 'BonusSection');
const OfferSection = named(() => import('./components/sections/OfferSection'), 'OfferSection');
const FaqSection = named(() => import('./components/sections/FaqSection'), 'FaqSection');
const FinalCta = named(() => import('./components/sections/FinalCta'), 'FinalCta');
const Footer = named(() => import('./components/Footer'), 'Footer');
const StickyBuyBar = named(() => import('./components/StickyBuyBar'), 'StickyBuyBar');
interface DeferredProps {
  children: React.ReactNode;
  minHeight: string;
  background?: string;
  id?: string;
}
function Deferred({
  children,
  minHeight,
  background = 'bg-charcoal',
  id
}: DeferredProps) {
  return <Suspense fallback={<div id={id} className={`w-full ${background}`} style={{
    minHeight
  }} aria-hidden data-id="element-1" data-mp="nur6e0oh68xc" />} data-id="element-0" data-mp="nwc2vvuco1xu">
      {children}
    </Suspense>;
}
export function App() {
  return <main className="w-full overflow-x-clip bg-charcoal text-white" data-id="element-2" data-mp="3688rpx40wyp">
      <Hero data-id="element-3" data-mp="38b5essrpoce" />
      <Deferred minHeight="64px" background="bg-bottle" data-id="element-4" data-mp="3uct2jhejuizf"><ValueStrip data-id="element-5" data-mp="3ubzu8bzxzlf6" /></Deferred>
      <Deferred minHeight="700px" background="bg-ivory" data-id="element-6" data-mp="3uevqzx020421"><AudiencePainSection data-id="element-7" data-mp="d4xq9hl3gfef" /></Deferred>
      <Deferred minHeight="900px" background="bg-charcoal" id="project-preview" data-id="element-8" data-mp="d3wa4yp812pu"><ProjectPreviewSection data-id="element-9" data-mp="86w7kxrkyi3h" /></Deferred>
      <Deferred minHeight="900px" background="bg-dune" id="volumes" data-id="element-10" data-mp="83qi3hf1he78"><CollectionSection data-id="element-11" data-mp="3gm65ruscn35z" /></Deferred>
      <Deferred minHeight="700px" background="bg-cream" id="bonuses" data-id="element-12" data-mp="3gj1qa19fol00"><BonusSection data-id="element-13" data-mp="3bnmjtudr9rdm" /></Deferred>
      <Deferred minHeight="900px" id="offer" data-id="element-14" data-mp="3bkgq21u6m1bk"><OfferSection data-id="element-15" data-mp="3qbfvx53mubrg" /></Deferred>
      <Deferred minHeight="300px" background="bg-ivory" id="guarantee" data-id="element-16" data-mp="3qcqzb3t61hi1"><GuaranteeSection data-id="element-17" data-mp="3lk7mi92ayqea" /></Deferred>
      <Deferred minHeight="800px" background="bg-dune" id="technical-proof" data-id="element-18" data-mp="3liwgs3par8kj"><TechProofSection data-id="element-19" data-mp="2xu3n6dw5dct3" /></Deferred>
      <Deferred minHeight="500px" background="bg-ivory" id="faq" data-id="element-20" data-mp="2xt2ak4zhgi99"><FaqSection data-id="element-21" data-mp="2swljp30wfpsh" /></Deferred>
      <Deferred minHeight="420px" data-id="element-22" data-mp="2svadyxnw87yq"><FinalCta data-id="element-23" data-mp="2stzbd166p697" /></Deferred>
      <Deferred minHeight="220px" background="bg-charcoal-deep" data-id="element-24" data-mp="18d9d06h7bks6"><Footer data-id="element-25" data-mp="18bokemeg6bwy" /></Deferred>
      <Suspense fallback={null} data-id="element-26" data-mp="1d47wtg1ef106"><StickyBuyBar data-id="element-27" data-mp="1d4ri96q9c7iy" /></Suspense>
    </main>;
}